import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=21c54f38&scoped=true"
import script from "./questions.vue?vue&type=script&lang=ts"
export * from "./questions.vue?vue&type=script&lang=ts"
import style0 from "./questions.vue?vue&type=style&index=0&id=21c54f38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c54f38",
  null
  
)

export default component.exports